import { RoutePath } from '../../../enums/RoutePath';

export const AccountSettingsRoutes: RoutePath[] = [
  RoutePath.AccountSettings,
  RoutePath.BillingStatements,
  RoutePath.EmailPreferences,
  RoutePath.MyFavourites,
];
